<div>
  <div class="container-fluid">
    <div class="row pb-2 pt-2 d-flex align-items-end">
      <div class="col-2" *ngIf="enableSearch">
        <mat-form-field>
          <mat-select placeholder="View" [(value)]="displayedPageSize">
            <mat-option (click)="setPageSize(10)" value="10">10</mat-option>
            <mat-option (click)="setPageSize(15)" value="10">15</mat-option>
            <mat-option (click)="setPageSize(25)" value="25">25</mat-option>
            <mat-option (click)="setPageSize(50)" value="50">50</mat-option>
            <mat-option (click)="setPageSize(100)" value="100">100</mat-option>
            <mat-option (click)="setPageSize(250)" value="250">250</mat-option>
            <mat-option (click)="setPageSize(9999999)" value="All">All</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-3 align-items-end">
        <form *ngIf="enableSearch" (ngSubmit)="submit()">
          <mat-form-field>
            <input matInput name="filter" [placeholder]="placeholder" type="text" [(ngModel)]="filter.text" />
          </mat-form-field>
        </form>
      </div>
      <div class="col-4" *ngIf="enableSearch">
        &nbsp;
        <button mat-raised-button class="primary" (click)="submit()">Search</button> &nbsp;
        <button mat-raised-button class="warning" [disabled]="loading" *ngIf="filter" (click)="reset()">Reset</button>
      </div>
      <div class="col d-flex justify-content-end align-items-baseline">
        <span>
          {{ filter.totalCount === 0 ? '0' : filter.pageMinimum}} -
          {{ filter.pageMaximum > filter.totalCount ? filter.totalCount : filter.pageMaximum }} of
          {{ filter.totalCount }}
        </span>
        <button mat-icon-button [disabled]="!(filter.page > 1)" (click)="getPreviousPage()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-icon-button [disabled]="!(filter.totalCount >= filter.pageSize * filter.page + 1)"
          (click)="getNextPage()">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="headers">
    <div class="alert alert-no-data" *ngIf="data?.length === 0 && !loading">
      <i class="fa fa-fw fa-exclamation-triangle"></i>
      <h4>No data found</h4>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <table class="table mat-table" *ngIf="data && data.length > 0">
      <thead>
        <tr class="mat-header-row">
          <th class="mat-header-cell" *ngFor="let header of headers" [ngClass]="header.class">{{header.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="mat-row" *ngFor="let input of data">
          <td class="mat-cell" *ngFor="let attribute of objectKeys(input) | filternotin : ignoreFields">
            <a href="{{input[attribute]}}" *ngIf="input[attribute].indexOf('http') !== -1">
              {{input[attribute]}}
            </a>
            <a href="mailto:{{attribute}}" *ngIf="validateEmail(input[attribute])">
              {{input[attribute]}}
            </a>
            <span *ngIf="input[attribute].indexOf('http') === -1 && !validateEmail(input[attribute])">
              {{input[attribute]}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>